/**
 * Map value on one range into another range. For example if your `num`
 * is in a scale of 1-100, and you want to map it to a scale of 0-1,
 * you could do something like:
 *
 * const value = 50;
 * mapInputOutput(value, 1, 100, 0, 1); => 0.5
 *
 * const value = 20;
 * mapInputOutput(value, 1, 100, 0, 1); => 0.2
 *
 * @param {number} num Input number
 * @param {number} inMin Minimum of the first range
 * @param {number} inMax Maximum of the first range
 * @param {number} outMin Minimum of the second range
 * @param {number} outMax Maximum of the second range
 * @return {number}
 */
export default (num, inMin, inMax, outMin, outMax) => (
  ((num - inMin) * (outMax - outMin)) / (inMax - inMin) + outMin
);
